import React from "react";
import ReactDOM from "react-dom";
import styles from "./style.module.scss";

import close from "../../assets/image/close.png";
import { CircleX } from "lucide-react";

function Modal({ children, setOpenModal, onClose }) {
  const handleClose = () => {
    setOpenModal(false);
    onClose?.(false);
  };

  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={styles.modal__container}>
        <button className={styles.modal__btn_icon} onClick={() => handleClose()}>
          <CircleX color="#fff" size={30} />
        </button>
        {children}
      </div>
    </div>,
    document.getElementById("modal-root"),
  );
}

export default Modal;
